import React, {Component} from 'react'
import Footer from '../Footer'
import { LanguageContext, LanguageConsumer } from '../lib/LanguageContext'
import { Errors } from './ErrorConfig'
import './Reference.css'

class Reference extends Component {


    render() {
      return (<LanguageConsumer>
        {({polyglot}) =>
          (
            <div className='Reference-wrapper'>
                <div className='Reference'>
                  <h2 className='header'>Reference</h2>
                  <div className='error-reference'>
                      <table cellSpacing='0' cellPadding='0'>
                        <thead>
                            <th>Code</th>
                            <th>Description</th>
                            <th>Fields</th>
                            <th>Severity</th>
                        </thead>
                        <tbody> 
                          {Errors.map(error =>
                            (<tr>
                               <td>
                                 {error.code}
                               </td>
                               <td>
                                 {polyglot.t(`errors.${error.code}`)}
                               </td>
                               <td>
                               </td>
                               <td>
                               </td>
                            </tr>)
                          )}
                        </tbody>
                      </table>
                 </div>
                </div>
                <Footer/>
            </div>
          )
        }
      </LanguageConsumer>)
    }

}

export default Reference



// WEBPACK FOOTER //
// ./src/help/Reference.js